export default __webpack_public_path__ + "static/media/question.b24740f2.svg";